import Fallback from './DashobardTemplates.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./DashboardTemplates.page'),
});
